import Heading from "components/Heading/Heading";
import React from "react";
import { TaxonomyType } from "data/types";
import CardCategory6 from "components/CardCategory6";

type SectionCategoryProps = {
	className?: string;
	itemClassName?: string;
	heading?: string;
	subHeading?: string;
	categories: TaxonomyType[];
	nextPrev?: boolean;
	isCenter?: boolean;
};

const DEMO_CATS: TaxonomyType[] = [
	{
		id: "1",
		href: "#",
		name: "A",
		taxonomy: "category",
		count: 17288,
		thumbnail:
			"https://images.pexels.com/photos/2581922/pexels-photo-2581922.jpeg?auto=compress&cs=tinysrgb&dpr=3&h=750&w=1260",
	},
	{
		id: "2",
		href: "#",
		name: "Transportasi",
		taxonomy: "category",
		count: 2118,
		thumbnail:
			"https://images.pexels.com/photos/2351649/pexels-photo-2351649.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
	},
	{
		id: "3",
		href: "#",
		name: "Pakaian",
		taxonomy: "category",
		count: 36612,
		thumbnail:
			"https://images.pexels.com/photos/962464/pexels-photo-962464.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
	},
	{
		id: "4",
		href: "#",
		name: "Farm House",
		taxonomy: "category",
		count: 188288,
		thumbnail:
			"https://images.pexels.com/photos/248837/pexels-photo-248837.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
	},
	{
		id: "5",
		href: "#",
		name: "Dome House",
		taxonomy: "category",
		count: 188288,
		thumbnail:
			"https://images.pexels.com/photos/3613236/pexels-photo-3613236.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
	},
	{
		id: "6",
		href: "#",
		name: "Dome House",
		taxonomy: "category",
		count: 188288,
		thumbnail:
			"https://images.pexels.com/photos/3613236/pexels-photo-3613236.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
	},
];
const SectionCategory = ({
	className = "",
	itemClassName,
	heading,
	subHeading,
	categories = DEMO_CATS,
	nextPrev = false,
	isCenter = true,
}: SectionCategoryProps) => {
	return (
		<div className={`nc-SectionSliderNewCategories ${className}`}>
			{" "}
			<Heading desc={subHeading} hasNextPrev={nextPrev} isCenter={isCenter}>
				{heading}
			</Heading>
			<div className="grid grid-rows-3 sm:grid-rows-1 sm:grid-cols-3 gap-x-6 gap-y-3">
				{categories.map((item, index) => {
					return (
						<CardCategory6
							key={item.id}
							taxonomy={item}
							className={itemClassName}
						></CardCategory6>
					);
				})}
			</div>
		</div>
	);
};

export default SectionCategory;
